import { BaseWidget } from './BaseWidget.js';

export class ButtonWidget extends BaseWidget {
	constructor(options) {
		super({ ...options, type: 'button' });
		this.isMinimized = false;
		this._hiddenForOpenPanel = false;
	}

	_render() {
		const buttonText =
			this.options.buttonText ||
			this.options.triggerText ||
			this.options.label ||
			this.options.text ||
			'Feedback';

		const button = document.createElement('div');
		button.className = `feedback-widget-button position-${this.options.position}`;
		button.innerHTML = `
      <button class="feedback-trigger-btn" type="button">
        <svg class="feedback-icon" width="20" height="20" viewBox="0 0 256 256" fill="currentColor">
          <path d="M216,80H184V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V176a8,8,0,0,0,13,6.22L72,154V184a16,16,0,0,0,16,16h93.59L219,230.22a8,8,0,0,0,5,1.78,8,8,0,0,0,8-8V96A16,16,0,0,0,216,80ZM66.55,137.78,40,159.25V48H168v88H71.58A8,8,0,0,0,66.55,137.78ZM216,207.25l-26.55-21.47a8,8,0,0,0-5-1.78H88V152h80a16,16,0,0,0,16-16V96h32Z"/>
        </svg>
        <span class="feedback-text">${buttonText}</span>
        
        <div class="feedback-minimize-icon">
          <svg viewBox="0 0 256 256">
            <path d="M213.66,53.66,163.31,104H192a8,8,0,0,1,0,16H144a8,8,0,0,1-8-8V64a8,8,0,0,1,16,0V92.69l50.34-50.35a8,8,0,0,1,11.32,11.32ZM112,136H64a8,8,0,0,0,0,16H92.69L42.34,202.34a8,8,0,0,0,11.32,11.32L104,163.31V192a8,8,0,0,0,16,0V144A8,8,0,0,0,112,136Z"/>
          </svg>
        </div>
        
        <div class="feedback-expand-icon">
          <svg viewBox="0 0 256 256">
            <path d="M112,40V64.69L61.66,14.34A8,8,0,0,0,50.34,25.66L100.69,76H72a8,8,0,0,0,0,16h48a8,8,0,0,0,8-8V36A8,8,0,0,0,112,40Zm131.06,70.61a8,8,0,0,0-8.72,1.73L184,162.69V136a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8h48a8,8,0,0,0,0-16H195.31l50.35-50.34A8,8,0,0,0,243.06,110.61Z"/>
          </svg>
        </div>
      </button>
    `;

		if (this.options.customStyles) {
			Object.assign(button.style, this.options.customStyles);
		}

		return button;
	}

	_attachEvents() {
		const button = this.element.querySelector('.feedback-trigger-btn');
		const minimizeIcon = this.element.querySelector('.feedback-minimize-icon');
		const expandIcon = this.element.querySelector('.feedback-expand-icon');
		const isControlIcon = (target) => {
			if (!(target instanceof Element)) return false;
			return Boolean(
				target.closest('.feedback-minimize-icon') ||
					target.closest('.feedback-expand-icon')
			);
		};
		const openIfAllowed = (target) => {
			if (isControlIcon(target)) {
				return;
			}
			if (!this.isMinimized) {
				this.openPanel();
			}
		};

		minimizeIcon.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();
			this.minimize();
		});

		expandIcon.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();
			this.restore();
		});

		button.addEventListener('click', (e) => {
			openIfAllowed(e.target);
		});

		// Pointer events improve consistency across touch and mouse devices.
		button.addEventListener('pointerup', (e) => {
			if (e.pointerType === 'mouse') return;
			openIfAllowed(e.target);
		});
	}

	minimize() {
		this.isMinimized = true;
		this.element.classList.add('minimized');
	}

	restore() {
		this.isMinimized = false;
		this.element.classList.remove('minimized');
	}

	openPanel() {
		if (!this.state.isOpen) {
			this._hiddenForOpenPanel = true;
			this.hide();
		}
		super.openPanel();
	}

	closePanel() {
		const shouldRestoreButton = this._hiddenForOpenPanel;
		super.closePanel();

		if (shouldRestoreButton) {
			setTimeout(() => {
				if (!this.destroyed) {
					this.show();
				}
				this._hiddenForOpenPanel = false;
			}, 320);
		}
	}

	mount(container) {
		super.mount(container);
	}

	updateText(text) {
		const textEl = this.element?.querySelector('.feedback-text');
		if (textEl) {
			textEl.textContent = text;
		}
	}

	updatePosition(position) {
		this.options.position = position;
		if (this.element) {
			this.element.className = this.element.className.replace(
				/position-\w+-\w+/,
				`position-${position}`
			);
		}
	}
}
